"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitingText = void 0;
const pixi_js_1 = require("pixi.js");
const gsap_1 = require("gsap");
const Global_1 = require("../Global");
class WaitingText extends pixi_js_1.Text {
    constructor(text, style, canvas) {
        super(text, style, canvas);
        this.dots = [];
        this.dots = this.makeDots();
        this.tm = this.makeTimeline();
    }
    makeTimeline() {
        const tm = gsap_1.gsap.timeline({ autoRemoveChildren: false, repeat: -1 });
        this.dots.forEach((d) => {
            tm.to(d, {
                pixi: {
                    alpha: 1.0
                },
                duration: 0.5,
                ease: 'none'
            });
        });
        this.dots.forEach((d, i) => {
            tm.to(d, {
                pixi: {
                    alpha: 0.0
                },
                duration: 0.3,
                ease: 'none'
            }, (i ? '<' : null));
        });
        return tm;
    }
    makeDots() {
        const dots = new Array(WaitingText.num);
        for (let i = 0; i < WaitingText.num; i++) {
            dots[i] = (new pixi_js_1.Graphics());
            dots[i].alpha = 0;
            this.addChild(dots[i]);
        }
        return dots;
    }
    updateText(respectDirty) {
        super.updateText(respectDirty);
        const y = (this.style.fontSize);
        const r = y / 18;
        const yfix = (0, Global_1.px)(13);
        const xoff = (0, Global_1.isrtl)() ? -(this.anchor.x * this.canvas.width) : (this.canvas.width - (this.anchor.x * this.canvas.width));
        this.dots.forEach((d, i) => {
            d.clear()
                .beginFill(this.style.fill.toString())
                .drawCircle(xoff + (i * r * 3.5) * ((0, Global_1.isrtl)() ? -1 : 1), this.canvas.height - (this.anchor.y * this.canvas.height) - yfix + r / 2, r);
        });
    }
    start() {
        this.tm.play(0);
    }
    stop() {
        this.tm.pause(0);
    }
    destroy(options) {
        var _a;
        (_a = this.tm) === null || _a === void 0 ? void 0 : _a.kill();
        super.destroy(options);
    }
    // Just to get Typescript to stop wining :(
    setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) {
        return super.setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY);
    }
}
exports.WaitingText = WaitingText;
WaitingText.num = 3;
